import React from 'react';
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


const NotFoundPage = () => {
    const navigate = useNavigate();
    const handleGoBack = () => {
    navigate("/"); // Replace '/your-target-link' with the path you want to navigate to
  };
        return (
            <Container fluid className="vh-100 d-flex align-items-center justify-content-center bg-light" style={{
        backgroundImage: `url('/assets/not_found_bg.jpg')`, // Replace with your pattern image path
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}>
      <Row className="text-center">
        <Col xs={12} className="d-flex flex-column justify-content-center align-items-center p-4">
          <h1 className="display-4 fw-bold">Ooops...</h1>
          <h3 className="text-secondary mb-4">Page not found</h3>
          <Button 
            size="lg" 
            className="mt-3" 
            onClick={handleGoBack}
            style={{
              backgroundColor: "#4FB3F9",
              borderColor: "#4FB3F9",
              color: "white"
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#0872BB";
              e.target.style.borderColor = "#0872BB";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#4FB3F9";
              e.target.style.borderColor = "#4FB3F9";
            }}
          >
            Go Back →
          </Button>
        </Col>
      </Row>
    </Container>
        );
    
}

export default NotFoundPage;